export class AuthConfig {

}
